<script>

    import { toast } from 'bulma-toast'
    import { providersStore, modalStore } from '../stores'

    import ProvidersService from '../$services/providers.service.js'
    import TranslateMethods from '../$methods/translate.methods'

    import Search from '../$components/input.search.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Table from '../$components/table.svelte'

    let loading = false
    let query = {
        find: null
    }

    getProviders()

    async function getProviders() {

        loading = true
        const resp = await ProvidersService.getProviders(null)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.set(resp.data)
    }

</script>

<Table items={ $providersStore.length } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getProviders } />
            </div>
            <div class="column is-narrow">
                <div>
                    <ButtonModal modalId="provider_create_modal" icon="plus" text="Agregar"/>
                </div>
            </div>
        </div>
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Proveedor</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $providersStore as provider, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ TranslateMethods.get(provider.status) }</td>
                <td>{ provider.name }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('provider', 'modal', provider)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>